import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Hero } from './components/sections/Hero';
import { About } from './components/sections/About';
import { Services } from './components/sections/Services';
import { Differentials } from './components/sections/Differentials';
import { Process } from './components/sections/Process';
import { CTA } from './components/sections/CTA';

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Differentials />
        <Process />
        <CTA />
      </main>
      <Footer />
    </>
  );
}

export default App;
